<template>
  <article class="col-lg-12 gp-campaign-detail pt-2">
    <div class="row">
      <div class="col-12 col-md-5">
        <div class="typo-h5 flex-v-center breadcrumb row flex-nowrap">
          <router-link :to="{ name: 'ABTesting' }" class="heading-16-medium text-dark6 rl">{{ $tc("generals.campaign", 2) }}</router-link>
          <i class="icon icon-arrow-right text-dark6"></i>
          <template v-if="details">
            <EllipsisTitle html-tag="span" class="heading-16-medium mr-1 text-light-high" :content="details.name" />
            <CampaignDropdown :item="details" @status:indicate="onStatusIndicate" @status:value="onStatusUpdate" @delete="onDelete" @rename="onRename" @setting="onSetting" :hides="['view', 'toggler', 'report']" />
          </template>
          <template v-else>
            <span class="heading-16-medium mr-1 text-light-high skeleton skeleton-light w200 h19"></span>
          </template>
        </div>
      </div>
      <div class="col-12 col-md-3 d-flex align-items-stretch flex-column">
        <div class="row align-items-center flex-grow-1">
          <div class="col-6">
            <p class="paragraph-12-medium text-light-low text-upper text-center flex-v-center" v-if="details">
              {{ statusFormat(details.status) }}
            </p>
            <p class="typo-heading16 typo-medium mr-1 text-light-high skeleton skeleton-light w55 h15" v-else></p>
          </div>
          <div class="col-6">
            <p class="paragraph-12-medium text-light-low text-center" v-if="details">
              <span v-if="dayPassed > 0 && dayPassed < details.duration">{{ dayPassed }}/</span>
              <span>{{ $tc("banner.trial.day", details.duration, { count: details.duration }) }}</span>
            </p>
            <p class="typo-heading16 typo-medium mr-1 text-light-high skeleton skeleton-light w38 h15" v-else></p>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4 pl-0">
        <div class="row justify-content-end">
          <template v-if="!noGAID">
            <router-link :to="{ name: 'CampaignReport' }" class="btn btn-square btn-setting order-1" :disabled="reportDisabled" :class="{ 'disabled': reportDisabled }" v-if="!isCompleted">
              <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.95455 17.75H9.04545C9.5 17.75 9.86364 17.5668 10.1364 17.2003L15.0455 11.2448C15.3182 10.9699 15.5 10.6034 15.5 10.1453V1.89921C15.5 0.982984 14.8636 0.25 14.0455 0.25H1.95455C1.13636 0.25 0.5 0.982984 0.5 1.89921V16.1008C0.5 17.017 1.13636 17.75 1.95455 17.75ZM1.59091 1.89921C1.59091 1.62435 1.77273 1.34948 1.95455 1.34948V1.4411H13.9545C14.1364 1.4411 14.3182 1.71597 14.3182 1.99084V9.96143H10.2275C9.40928 9.96143 8.77292 10.6944 8.77292 11.6106V16.6505H1.95455C1.77273 16.6505 1.59091 16.3757 1.59091 16.1008V1.89921ZM9.86383 15.8007L13.8432 11.0609H10.2275C10.0456 11.0609 9.86383 11.2441 9.86383 11.6106V15.8007ZM12.4092 5.74694H3.68198C3.40925 5.74694 3.13652 5.47207 3.13652 5.1972C3.13652 4.92233 3.40925 4.64746 3.68198 4.64746H12.3183C12.5911 4.64746 12.8638 4.92233 12.8638 5.1972C12.8638 5.47207 12.682 5.74694 12.4092 5.74694ZM3.68198 8.95397H7.50016C7.77288 8.95397 8.04561 8.6791 8.04561 8.40423C8.04561 8.12936 7.77288 7.85449 7.50016 7.85449H3.68198C3.40925 7.85449 3.13652 8.12936 3.13652 8.40423C3.13652 8.6791 3.40925 8.95397 3.68198 8.95397Z" fill="#676767"/>
              </svg>
            </router-link>
            <router-link :to="{ name: 'CampaignReport' }" class="btn btn-primary btn-default px-3 ml-1 order-3" :disabled="reportDisabled" :class="{ 'disabled': reportDisabled }" v-else>
              <svg class="mr-1" width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.95455 17.75H9.04545C9.5 17.75 9.86364 17.5668 10.1364 17.2003L15.0455 11.2448C15.3182 10.9699 15.5 10.6034 15.5 10.1453V1.89921C15.5 0.982984 14.8636 0.25 14.0455 0.25H1.95455C1.13636 0.25 0.5 0.982984 0.5 1.89921V16.1008C0.5 17.017 1.13636 17.75 1.95455 17.75ZM1.59091 1.89921C1.59091 1.62435 1.77273 1.34948 1.95455 1.34948V1.4411H13.9545C14.1364 1.4411 14.3182 1.71597 14.3182 1.99084V9.96143H10.2275C9.40928 9.96143 8.77292 10.6944 8.77292 11.6106V16.6505H1.95455C1.77273 16.6505 1.59091 16.3757 1.59091 16.1008V1.89921ZM9.86383 15.8007L13.8432 11.0609H10.2275C10.0456 11.0609 9.86383 11.2441 9.86383 11.6106V15.8007ZM12.4092 5.74694H3.68198C3.40925 5.74694 3.13652 5.47207 3.13652 5.1972C3.13652 4.92233 3.40925 4.64746 3.68198 4.64746H12.3183C12.5911 4.64746 12.8638 4.92233 12.8638 5.1972C12.8638 5.47207 12.682 5.74694 12.4092 5.74694ZM3.68198 8.95397H7.50016C7.77288 8.95397 8.04561 8.6791 8.04561 8.40423C8.04561 8.12936 7.77288 7.85449 7.50016 7.85449H3.68198C3.40925 7.85449 3.13652 8.12936 3.13652 8.40423C3.13652 8.6791 3.40925 8.95397 3.68198 8.95397Z" fill="#676767"/>
              </svg>
              {{ $t("analytic.ab.viewReport") }}
            </router-link>
          </template>
          <template v-else>
            <button class="btn btn-square btn-setting order-1 disabled" v-if="!isCompleted" v-popover:tooltip.bottom="btnReportTooltip">
              <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.95455 17.75H9.04545C9.5 17.75 9.86364 17.5668 10.1364 17.2003L15.0455 11.2448C15.3182 10.9699 15.5 10.6034 15.5 10.1453V1.89921C15.5 0.982984 14.8636 0.25 14.0455 0.25H1.95455C1.13636 0.25 0.5 0.982984 0.5 1.89921V16.1008C0.5 17.017 1.13636 17.75 1.95455 17.75ZM1.59091 1.89921C1.59091 1.62435 1.77273 1.34948 1.95455 1.34948V1.4411H13.9545C14.1364 1.4411 14.3182 1.71597 14.3182 1.99084V9.96143H10.2275C9.40928 9.96143 8.77292 10.6944 8.77292 11.6106V16.6505H1.95455C1.77273 16.6505 1.59091 16.3757 1.59091 16.1008V1.89921ZM9.86383 15.8007L13.8432 11.0609H10.2275C10.0456 11.0609 9.86383 11.2441 9.86383 11.6106V15.8007ZM12.4092 5.74694H3.68198C3.40925 5.74694 3.13652 5.47207 3.13652 5.1972C3.13652 4.92233 3.40925 4.64746 3.68198 4.64746H12.3183C12.5911 4.64746 12.8638 4.92233 12.8638 5.1972C12.8638 5.47207 12.682 5.74694 12.4092 5.74694ZM3.68198 8.95397H7.50016C7.77288 8.95397 8.04561 8.6791 8.04561 8.40423C8.04561 8.12936 7.77288 7.85449 7.50016 7.85449H3.68198C3.40925 7.85449 3.13652 8.12936 3.13652 8.40423C3.13652 8.6791 3.40925 8.95397 3.68198 8.95397Z" fill="#676767"/>
              </svg>
            </button>
            <button class="btn btn-primary btn-default px-3 ml-1 order-3 disabled" v-else v-popover:tooltip.bottom="btnReportTooltip">
              <svg class="mr-1" width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.95455 17.75H9.04545C9.5 17.75 9.86364 17.5668 10.1364 17.2003L15.0455 11.2448C15.3182 10.9699 15.5 10.6034 15.5 10.1453V1.89921C15.5 0.982984 14.8636 0.25 14.0455 0.25H1.95455C1.13636 0.25 0.5 0.982984 0.5 1.89921V16.1008C0.5 17.017 1.13636 17.75 1.95455 17.75ZM1.59091 1.89921C1.59091 1.62435 1.77273 1.34948 1.95455 1.34948V1.4411H13.9545C14.1364 1.4411 14.3182 1.71597 14.3182 1.99084V9.96143H10.2275C9.40928 9.96143 8.77292 10.6944 8.77292 11.6106V16.6505H1.95455C1.77273 16.6505 1.59091 16.3757 1.59091 16.1008V1.89921ZM9.86383 15.8007L13.8432 11.0609H10.2275C10.0456 11.0609 9.86383 11.2441 9.86383 11.6106V15.8007ZM12.4092 5.74694H3.68198C3.40925 5.74694 3.13652 5.47207 3.13652 5.1972C3.13652 4.92233 3.40925 4.64746 3.68198 4.64746H12.3183C12.5911 4.64746 12.8638 4.92233 12.8638 5.1972C12.8638 5.47207 12.682 5.74694 12.4092 5.74694ZM3.68198 8.95397H7.50016C7.77288 8.95397 8.04561 8.6791 8.04561 8.40423C8.04561 8.12936 7.77288 7.85449 7.50016 7.85449H3.68198C3.40925 7.85449 3.13652 8.12936 3.13652 8.40423C3.13652 8.6791 3.40925 8.95397 3.68198 8.95397Z" fill="#676767"/>
              </svg>
              {{ $t("analytic.ab.viewReport") }}
            </button>
          </template>

          <button class="btn btn-square btn-setting ml-4px ml-xl-1 order-2" @click="openModal('settings')" :disabled="loading || !details || (details && details.status == 'running')">
            <i class="icon icon-settings typo-icon-20"></i>
          </button>

          <!-- START/STOP/RESTART -->
          <button class="btn" :class="btnStart" v-if="details.indicating" @click.stop>
            <svg class="spinning" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" :width="isCompleted ? 20 : 16" :height="isCompleted ? 20 : 16" viewBox="0 0 512 512">
              <path fill="currentColor" d="M456.433 371.72l-27.79-16.045c-7.192-4.152-10.052-13.136-6.487-20.636 25.82-54.328 23.566-118.602-6.768-171.03-30.265-52.529-84.802-86.621-144.76-91.424C262.35 71.922 256 64.953 256 56.649V24.56c0-9.31 7.916-16.609 17.204-15.96 81.795 5.717 156.412 51.902 197.611 123.408 41.301 71.385 43.99 159.096 8.042 232.792-4.082 8.369-14.361 11.575-22.424 6.92z" />
            </svg>
            <p class="typo-button14 ml-4px ml-xl-1" v-if="!isCompleted">
              <span v-if="['on_hold', 'completed'].includes(details.status)">{{ $t("analytic.ab.startCamp") }}</span>
              <span v-if="details.status == 'running'">{{ $t("analytic.ab.stopCamp") }}</span>
            </p>
          </button>
          <template v-else>
            <template v-if="['on_hold', 'completed'].includes(details.status)">
              <button class="btn" :class="btnStart" :disabled="details.isLimitStartCampaign" @click.stop="start">
                <i class="icon icon-start" :class="[{ 'typo-icon-16': !isCompleted }, { 'typo-icon-20': isCompleted }]"></i>
                <p class="typo-button14 ml-4px ml-xl-1" v-if="!isCompleted">
                  <span>{{ $t("analytic.ab.startCamp") }}</span>
                </p>
              </button>
            </template>
            <template v-if="details.status == 'running'">
              <button class="btn" :class="btnStart" @click.stop="stop">
                <i class="icon icon-stop" :class="[{ 'typo-icon-16': !isCompleted }, { 'typo-icon-20': isCompleted }]"></i>
                <p class="typo-button14 ml-4px ml-xl-1" v-if="!isCompleted">
                  <span>{{ $t("analytic.ab.stopCamp") }}</span>
                </p>
              </button>
            </template>
          </template>
        </div>
      </div>
      <div class="col-12 mt-2 px-0" v-if="noGAID">
        <div class="warning-no-tracking d-flex">
          <div class="img d-flex align-items-start">
            <svg width="20" height="23" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_2335_3070)">
                <path d="M19.7988 19.8199L11.5616 3.48095C11.4123 3.18506 11.1879 2.93723 10.9127 2.76432C10.6376 2.59141 10.3221 2.5 10.0004 2.5C9.67882 2.5 9.36333 2.59141 9.08814 2.76432C8.81295 2.93723 8.58857 3.18506 8.43928 3.48095L0.201219 19.8199C0.0604994 20.0989 -0.00851853 20.4109 0.000839418 20.7258C0.0101974 21.0406 0.0976145 21.3477 0.254637 21.6172C0.41166 21.8867 0.632976 22.1095 0.897182 22.2642C1.16139 22.4188 1.45955 22.5001 1.76282 22.5H18.2372C18.5405 22.5001 18.8386 22.4188 19.1028 22.2642C19.367 22.1095 19.5883 21.8867 19.7454 21.6172C19.9024 21.3477 19.9898 21.0406 19.9992 20.7258C20.0085 20.4109 19.9395 20.0989 19.7988 19.8199ZM9.11874 9.22291C9.11874 8.98015 9.21158 8.74733 9.37685 8.57567C9.54212 8.40401 9.76627 8.30757 10 8.30757C10.2337 8.30757 10.4579 8.40401 10.6231 8.57567C10.7884 8.74733 10.8813 8.98015 10.8813 9.22291V14.715C10.8813 14.9578 10.7884 15.1906 10.6231 15.3622C10.4579 15.5339 10.2337 15.6303 10 15.6303C9.76627 15.6303 9.54212 15.5339 9.37685 15.3622C9.21158 15.1906 9.11874 14.9578 9.11874 14.715V9.22291ZM10.0441 19.7585H10.0194C9.67185 19.7574 9.33821 19.6167 9.08823 19.3659C8.83825 19.1152 8.69129 18.7737 8.6781 18.413C8.67175 18.2336 8.69989 18.0547 8.76086 17.8867C8.82184 17.7187 8.91443 17.565 9.03324 17.4346C9.15204 17.3043 9.29467 17.1998 9.4528 17.1273C9.61092 17.0548 9.78137 17.0158 9.95417 17.0125H9.97885C10.3263 17.0129 10.6602 17.1529 10.9105 17.4032C11.1608 17.6535 11.3082 17.9947 11.3219 18.3553C11.3287 18.5351 11.3009 18.7145 11.24 18.883C11.1791 19.0515 11.0864 19.2056 10.9674 19.3363C10.8483 19.4671 10.7053 19.5718 10.5468 19.6443C10.3882 19.7168 10.2173 19.7556 10.0441 19.7585Z" fill="#494949"/>
              </g>
              <defs>
                <clipPath id="clip0_2335_3070">
                  <rect width="20" height="22.5" fill="white"/>
                </clipPath>
              </defs>
            </svg>

          </div>
          <div class="ml-1 content d-flex align-items-start">
            <p class="text-light-high paragraph-14-regular" v-html="$t('analytic.ab.warnNoTrackID')"></p>
          </div>
        </div>
      </div>
    </div>

    <template v-if="details">
      <div class="row mt-3 justify-content-between align-items-center">
        <span class="button-14-medium text-light-high">{{ $t("analytic.ab.original") }}
          <Icon :hasTooltip="true" :tooltipText="$t('analytic.ab.tooltip.original')" iClass="ml-half" />
        </span>
        <div class="d-flex ml-auto align-items-center" v-if="testURL">
          <p class="body-12-regular text-light-low ellipsis mr-2" style="max-width: 40vw;">
            {{ $t("analytic.ab.testURL") }}:
            <a class="text-light-low" :href="(mainPage && mainPage.preview_url) || ''" target="_blank">{{ testURL }}</a>
          </p>
          <button class="btn btn-copy btn-clean body-12-regular" :class="{ 'pe-none': copied }" @click="copyURL">
            <template v-if="!copied">{{ $t("generals.copy") }}</template>
            <template v-else>
              <i class="icon icon-check typo-icon-12 text-accent-green"></i>
            </template>
          </button>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <table class="statistic row">
            <thead class="col-12">
              <tr class="row typo-medium">
                <th class="body-12-regular text-light-low col-8 text-left pl-2">{{ $t("analytic.ab.pageName") }}</th>
                <th class="body-12-regular text-light-low col-2">
                  {{ $tc("analytic.ab.traffic", 2) }}
                </th>
                <th class="body-12-regular text-light-low col-2">
                  {{ $t("analytic.ab.actions") }}
                </th>
              </tr>
            </thead>
            <tbody class="col-12">
              <template v-if="loading">
                <PageReportItem loading>
                  <td class="typo-regular text-light-low col-8 text-left">
                    <p class="skeleton skeleton-light w250 h19"></p>
                    <p class="skeleton skeleton-light w200 h15 mt-1"></p>
                  </td>
                  <td class="typo-regular text-light-low col-2">
                    <p class="skeleton skeleton-light w25 h17"></p>
                    <p class="skeleton skeleton-light w100 h15 mt-1"></p>
                  </td>
                  <td class="typo-regular text-light-low col-2">
                    <p class="skeleton skeleton-light w50 h17"></p>
                    <p class="skeleton skeleton-light w100 h15 mt-1"></p>
                  </td>
                </PageReportItem>
              </template>
              <template v-else>
                <PageReportItem :item="mainPage">
                  <template v-slot:default="{ item, lastModified, pageType }">
                    <td class="col-8 text-left px-2">
                      <EllipsisTitle class="heading-16-medium text-light-high" :content="item.g_title" />
                      <p class="d-flex align-items-center body-12-regular text-dark6 mt-1">
                        <span v-if="pageType">
                          {{ pageType }}
                        </span>
                        <svg v-if="pageType" class="mx-4px" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M4.93934 4.93934C5.52513 4.35355 6.47487 4.35355 7.06066 4.93934C7.64645 5.52513 7.64645 6.47487 7.06066 7.06066C6.47487 7.64645 5.52513 7.64645 4.93934 7.06066C4.35355 6.47487 4.35355 5.52513 4.93934 4.93934Z" fill="#676767"/>
                        </svg>
                        <span>{{ $t("generals.lastModified") }} {{ lastModified }}</span>
                      </p>
                    </td>
                    <td class="col-2">
                      <div class="d-flex align-items-center">
                        <template v-if="variants && variants.length">
                          <span class="body-12-regular text-light-high">{{ parseInt(item.percent * 100) }}%</span>
                          <button class="btn btn-light3 ml-1 p-half" @click="openModal('percent')" v-if="details.status != 'running'">
                            <i class="icon icon-pen typo-icon-16"></i>
                          </button>
                        </template>
                        <span class="body-12-regular text-light-high" v-else>100%</span>
                      </div>
                    </td>
                    <td class="col-2">
                      <div class="d-flex flex-row-reverse p-0">
                        <div class="page-item-tools d-flex">
                          <div class="page-item-tools-mini">
                            <PageReportDropdown :cID="details.id" :item="item" :disable="mainDisable" :options="['edit', 'rename', 'duplicate']" />
                          </div>
                        </div>
                        <div class="page-item-tools-preview mr-1" v-popover:tooltip.bottom="$t('generals.preview')">
                          <component :is="item.preview_url ? 'a': 'div'" target="_blank" :disabled="!item.preview_url" class="btn btn-square btn-preview" :class="previewClassByItem(item)" :href="item.preview_url || ''">
                            <svg v-if="item.preview_url" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4.52792 10.0833C4.52792 10.0833 6.75015 6.75 10.0835 6.75C13.4168 6.75 15.639 10.0833 15.639 10.0833C15.639 10.0833 13.4168 13.4167 10.0835 13.4167C6.75015 13.4167 4.52792 10.0833 4.52792 10.0833Z" stroke="#676767" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M11.4722 10.0832C11.4722 9.31616 10.8504 8.69434 10.0833 8.69434C9.31625 8.69434 8.69443 9.31616 8.69443 10.0832C8.69443 10.8503 9.31625 11.4721 10.0833 11.4721C10.8504 11.4721 11.4722 10.8503 11.4722 10.0832Z" stroke="#676767" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M1.75 4.52778V2.86111C1.75 2.56643 1.86706 2.28381 2.07544 2.07544C2.28381 1.86706 2.56643 1.75 2.86111 1.75H4.52778" stroke="#676767" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M18.4168 4.52778V2.86111C18.4168 2.56643 18.2997 2.28381 18.0913 2.07544C17.883 1.86706 17.6004 1.75 17.3057 1.75H15.639" stroke="#676767" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M1.75 15.6387V17.3053C1.75 17.6 1.86706 17.8826 2.07544 18.091C2.28381 18.2994 2.56643 18.4164 2.86111 18.4164H4.52778" stroke="#676767" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M18.4167 15.6387V17.3053C18.4167 17.6 18.2996 17.8826 18.0913 18.091C17.8829 18.2994 17.6003 18.4164 17.3056 18.4164H15.6389" stroke="#676767" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <i v-else class="icon icon-view-off typo-icon-20"></i>
                          </component>
                        </div>
                      </div>
                    </td>
                  </template>
                </PageReportItem>
              </template>
            </tbody>
          </table>
        </div>
      </div>

      <!-- VARIANTS -->
      <div class="row mt-3 justify-content-between align-items-end">
        <span class="button-14-medium text-light-high">{{ $tc("analytic.ab.variant", 1) }}
          <Icon :hasTooltip="true" :tooltipText="$t('analytic.ab.tooltip.variation')" iClass="ml-half" />
        </span>
        <div class="d-flex ml-auto align-items-center">
          <!-- sorry :< -->
          <button class="btn btn-secondary btn-default button-14-medium px-3 py-12px disabled" v-if="loading || (variants && variants.length)" v-popover:tooltip.bottom="$t('analytic.ab.onlyOneVariant')">
            <span class="mr-1">
              <i class="icon icon-plus typo-icon-12"></i>
            </span>
            <span>{{ $t("analytic.ab.addVariant") }}</span>
          </button>
          <button class="btn btn-secondary btn-default button-14-medium px-3 py-12px disabled" v-else-if="details && details.status == 'running'" v-popover:tooltip.bottom="$t('analytic.ab.runningNoAdd')">
            <span class="mr-1">
              <i class="icon icon-plus typo-icon-12"></i>
            </span>
            <span>{{ $t("analytic.ab.addVariant") }}</span>
          </button>
          <button class="btn btn-secondary btn-default button-14-medium px-3 py-12px" v-else @click="openModal('addVariant')">
            <span class="mr-1">
              <i class="icon icon-plus typo-icon-12"></i>
            </span>
            <span>{{ $t("analytic.ab.addVariant") }}</span>
          </button>
        </div>
      </div>

      <div class="row mt-2" v-if="loading || (variants && variants.length)">
        <div class="col-12">
          <table class="statistic row">
            <thead class="col-12">
              <tr class="row typo-medium">
                <th class="body-12-regular text-light-low col-8 text-left pl-2">{{ $t("analytic.ab.pageName") }}</th>
                <th class="body-12-regular text-light-low col-2">
                  {{ $tc("analytic.ab.traffic", 2) }}
                </th>
                <th class="body-12-regular text-light-low col-2">
                  {{ $t("analytic.ab.actions") }}
                </th>
              </tr>
            </thead>
            <tbody class="col-12">
              <template v-if="loading">
                <PageReportItem loading>
                  <td class="typo-regular text-light-low col-8 text-left">
                    <p class="skeleton skeleton-light w250 h19"></p>
                    <p class="skeleton skeleton-light w200 h15 mt-1"></p>
                  </td>
                  <td class="typo-regular text-light-low col-2">
                    <p class="skeleton skeleton-light w25 h17"></p>
                    <p class="skeleton skeleton-light w100 h15 mt-1"></p>
                  </td>
                  <td class="typo-regular text-light-low col-2">
                    <p class="skeleton skeleton-light w50 h17"></p>
                    <p class="skeleton skeleton-light w100 h15 mt-1"></p>
                  </td>
                </PageReportItem>
              </template>
              <template v-else-if="variants && variants.length">
                <PageReportItem v-for="(page, idx) in variants" :key="'page-variant_' + idx" :item="page">
                  <template v-slot:default="{ item, lastModified, pageType }">
                    <td class="col-8 text-left px-2">
                      <EllipsisTitle class="heading-16-medium text-light-high" :content="item.g_title" />
                      <p class="d-flex align-items-center body-12-regular text-dark6 mt-1">
                        <span v-if="pageType">
                          {{ pageType }}
                        </span>
                        <svg v-if="pageType" class="mx-4px" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M4.93934 4.93934C5.52513 4.35355 6.47487 4.35355 7.06066 4.93934C7.64645 5.52513 7.64645 6.47487 7.06066 7.06066C6.47487 7.64645 5.52513 7.64645 4.93934 7.06066C4.35355 6.47487 4.35355 5.52513 4.93934 4.93934Z" fill="#676767"/>
                        </svg>
                        <span>{{ $t("generals.lastModified") }} {{ lastModified }}</span>
                      </p>
                    </td>
                    <td class="col-2">
                      <div class="d-flex align-items-center">
                        <span class="body-12-regular text-light-high">{{ parseInt(item.percent * 100) }}%</span>
                        <button class="btn btn-light3 ml-1 p-half" @click="openModal('percent')" v-if="details.status != 'running'">
                          <i class="icon icon-pen typo-icon-16"></i>
                        </button>
                      </div>
                    </td>
                    <td class="col-2">
                      <div class="d-flex flex-row-reverse p-0">
                        <div class="page-item-tools d-flex">
                          <div class="page-item-tools-mini">
                            <PageReportDropdown :cID="details.id" :item="item" :disable="variantDisable" :options="['edit', 'rename', 'changeVariant', 'delete']" @duplicate="appendPage" @changeVariant="openChangeVariant" />
                          </div>
                        </div>
                        <div class="page-item-tools-preview mr-1" v-popover:tooltip.bottom="$t('generals.preview')">
                          <component :is="item.preview_url ? 'a': 'div'" target="_blank" :disabled="!item.preview_url" class="btn btn-square btn-preview" :class="previewClassByItem(item)" :href="item.preview_url || ''">
                            <svg v-if="item.preview_url" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4.52792 10.0833C4.52792 10.0833 6.75015 6.75 10.0835 6.75C13.4168 6.75 15.639 10.0833 15.639 10.0833C15.639 10.0833 13.4168 13.4167 10.0835 13.4167C6.75015 13.4167 4.52792 10.0833 4.52792 10.0833Z" stroke="#676767" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M11.4722 10.0832C11.4722 9.31616 10.8504 8.69434 10.0833 8.69434C9.31625 8.69434 8.69443 9.31616 8.69443 10.0832C8.69443 10.8503 9.31625 11.4721 10.0833 11.4721C10.8504 11.4721 11.4722 10.8503 11.4722 10.0832Z" stroke="#676767" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M1.75 4.52778V2.86111C1.75 2.56643 1.86706 2.28381 2.07544 2.07544C2.28381 1.86706 2.56643 1.75 2.86111 1.75H4.52778" stroke="#676767" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M18.4168 4.52778V2.86111C18.4168 2.56643 18.2997 2.28381 18.0913 2.07544C17.883 1.86706 17.6004 1.75 17.3057 1.75H15.639" stroke="#676767" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M1.75 15.6387V17.3053C1.75 17.6 1.86706 17.8826 2.07544 18.091C2.28381 18.2994 2.56643 18.4164 2.86111 18.4164H4.52778" stroke="#676767" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M18.4167 15.6387V17.3053C18.4167 17.6 18.2996 17.8826 18.0913 18.091C17.8829 18.2994 17.6003 18.4164 17.3056 18.4164H15.6389" stroke="#676767" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <i v-else class="icon icon-view-off typo-icon-20"></i>
                          </component>
                        </div>
                      </div>
                    </td>
                  </template>
                </PageReportItem>
              </template>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row mt-2 flex-column justify-content-center align-items-center p-6" v-else>
        <svg class="text-light-disabled" width="90" height="90" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M20.4826 61.894C29.0334 61.894 35.9652 54.9622 35.9652 46.4113C35.9652 37.8605 29.0334 30.9287 20.4826 30.9287C11.9318 30.9287 5 37.8605 5 46.4113C5 54.9622 11.9318 61.894 20.4826 61.894ZM20.4826 64.894C30.6903 64.894 38.9652 56.619 38.9652 46.4113C38.9652 36.2037 30.6903 27.9287 20.4826 27.9287C10.275 27.9287 2 36.2037 2 46.4113C2 56.619 10.275 64.894 20.4826 64.894Z" fill="currentColor" />
          <path fill-rule="evenodd" clip-rule="evenodd" d="M43.5864 71.6359L30.8667 58.9162L32.988 56.7949L45.7077 69.5146L43.5864 71.6359Z" fill="currentColor" />
          <path d="M37.8919 20C37.9115 23.3133 35.2416 26.0159 31.9272 26.0355C35.2416 26.0159 37.9435 28.6865 37.963 32C37.9435 28.6865 40.614 25.9841 43.9272 25.9644C40.614 25.9841 37.9115 23.3133 37.8919 20Z" fill="currentColor" />
          <path d="M10.4794 66C10.4908 67.9328 8.9334 69.5093 7 69.5207C8.9334 69.5093 10.5095 71.0671 10.5208 73C10.5095 71.0671 12.0673 69.4907 14 69.4792C12.0673 69.4907 10.4908 67.9328 10.4794 66Z" fill="currentColor" />
          <path fill-rule="evenodd" clip-rule="evenodd" d="M18 53H75V11L18 11L18 53ZM18 8C16.3431 8 15 9.34315 15 11V53C15 54.6569 16.3431 56 18 56H75C76.6569 56 78 54.6569 78 53V11C78 9.34315 76.6569 8 75 8H18Z" fill="currentColor" />
          <path d="M60.2374 17C62.4286 17 64.1992 17.6197 65.5493 18.8592C66.8994 20.0986 67.5745 21.7586 67.5745 23.8391C67.5745 26.163 66.8552 27.8894 65.4165 29.0181C63.9779 30.1248 62.0302 30.6781 59.5735 30.6781L59.4739 33.832H56.8511L56.7183 28.5866H57.6811C59.8723 28.5866 61.5876 28.2546 62.827 27.5906C64.0664 26.9266 64.6862 25.6761 64.6862 23.8391C64.6862 22.5111 64.2878 21.4598 63.491 20.6851C62.6942 19.9105 61.6208 19.5231 60.2706 19.5231C58.8984 19.5231 57.8139 19.8994 57.0171 20.6519C56.2425 21.3823 55.8551 22.3894 55.8551 23.6731H53C53 22.3451 53.2988 21.1831 53.8964 20.1871C54.494 19.169 55.335 18.3833 56.4195 17.83C57.5262 17.2767 58.7988 17 60.2374 17ZM58.1459 40.6379C57.5704 40.6379 57.0835 40.4387 56.6851 40.0403C56.2867 39.6419 56.0875 39.155 56.0875 38.5795C56.0875 38.0041 56.2867 37.5172 56.6851 37.1188C57.0835 36.7204 57.5704 36.5212 58.1459 36.5212C58.6992 36.5212 59.164 36.7204 59.5403 37.1188C59.9387 37.5172 60.1378 38.0041 60.1378 38.5795C60.1378 39.155 59.9387 39.6419 59.5403 40.0403C59.164 40.4387 58.6992 40.6379 58.1459 40.6379Z" fill="currentColor" />
        </svg>
        <p class="typo-paragraph16 typo-regular text-light-low mt-4 text-center" v-html="$t('analytic.ab.noVariant')"></p>
      </div>
      <ModalSelectPage :type="mainPage.g_type" :primaryText="getPrimaryText()" :take="1" :titles="['analytic.ab.selectVariant', 'analytic.ab.ready']" @close="closeModal('addVariant')" v-if="isModalActive('addVariant')" @select="addVariant" :btnStatus.sync="btnStatus" :selecteds="selectedIDs" />
      <ModalSelectPage :type="mainPage.g_type" :primaryText="getPrimaryText('analytic.ab.changeVar')" :take="1" :titles="['analytic.ab.changeVar', 'analytic.ab.ready']" @close="closeChangeVariant" v-if="isModalActive('changeVariant')" @select="changeVariant" :btnStatus.sync="btnStatus" :selecteds="selectedIDs" />
      <SettingModal type="settings" v-if="modals.settings.active" :item="modals.settings.active ? details : null" @close="closeModal('settings')" @setting="onSetting" />
      <!-- <ReportModal v-if="modals.report.active" :campaign="modals.report.active ? details : null" @close="closeModal('report')" /> -->
      <ModalUpdatePercent v-if="modals.percent.active" :campaign="details" @close="closeModal('percent')" @change="onUpdatePercent" />
    </template>
  </article>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { actions } from "@/store/analytic/types.js";
import { PageReportItem, PageReportDropdown, ModalSelectPage, CampaignDropdown, /*ReportModal,*/ ModalUpdatePercent, EllipsisTitle } from "../components";
import copyToClipboard from "@/utils/copyToClipboard.js";
import { statusFormat } from "@/store/analytic/getters.js";
import SettingModal from "../components/SettingModal.vue";
import processButton from "@/mixins/processButton.js";
import errorHandle from "@/mixins/errorHandle.js";
import routeGuard from "@/mixins/routeGuard.js";
import camelToSnake from '@/plugins/lodash/camelToSnake';
import Icon from "@/core/shared/Icon.vue"

export default {
  name: "CampaignDetail",
  components: {
    CampaignDropdown,
    PageReportItem,
    PageReportDropdown,
    ModalSelectPage,
    // ReportModal,
    ModalUpdatePercent,
    SettingModal,
    Icon,
    EllipsisTitle
  },
  mixins: [processButton(false), errorHandle(), routeGuard("analytics")],
  data: () => ({
    loading: false,
    fetched: null,
    copied: false,
    alertText: "",
    modals: {
      addVariant: {
        active: false
      },
      report: {
        active: false
      },
      settings: {
        active: false
      },
      percent: {
        active: false
      },
      changeVariant: {
        active: false,
        oldID: null
      }
    }
  }),
  computed: {
    ...mapState("analytic", {
      attach: state => state.attach
    }),
    ...mapState("account", {
      shopInfo: state => state.shopInfo
    }),
    reportDisabled() {
      return this.noGAID || this.loading || !this.details || (this.details && this.details.status == 'on_hold');
    },
    details() {
      let output = {};
      if (this.attach) {
        output = JSON.parse(JSON.stringify(this.attach));
      }
      if (this.fetched) {
        output = { ...output, ...JSON.parse(JSON.stringify(this.fetched)) };
      }
      return output;

    },
    selectedIDs() {
      const output = [];
      if (this.fetched) {
        return this.fetched.pages.map(x => (x.g_id));
      }
      return output;
    },
    mainPage() {
      if (!this.details || !this.details.pages) {
        return null;
      }
      return this.details.pages.find(x => x.is_main_page);
    },
    mainDisable() {
      let options = ["delete"];
      if (this.variants && this.variants.length) {
        options.push("duplicate");
      }
      if (this.details.status == "running") {
        options.push("edit");
      }
      return options;
    },
    variantDisable() {
      let options = [];
      if (this.details.status == "running") {
        options.push("edit");
        options.push("delete");
      }
      return options;
    },
    variants() {
      return( this.details?.pages || []).filter(x => !x.is_main_page);
    },
    testURL() {
      if (!this.mainPage) {
        return "";
      }
      return this.mainPage.preview_url;
    },
    dayPassed() {
      if (!this.details || !this.details.started_at) {
        return 0;
      }
      let passed = Math.round((new Date() - new Date(this.details.started_at)) / 86400000);
      if (passed > this.details.duration) {
        return this.details.duration;
      }
      return passed;
    },
    isCompleted() {
      const status = (this.details && this.details.status) || "on_hold";
      return status == "completed";
    },
    btnReport() {
      const status = (this.details && this.details.status) || "on_hold";
      if (status == "completed") {
        return "full";
        // return "btn-primary btn-default px-3 ml-1";
      }
      return "minimize";
      // return "btn-square btn-setting";
    },
    btnStart() {
      const status = (this.details && this.details.status) || "on_hold";
      if (status == "completed") {
        return "btn-square btn-setting order-1";
      } else if (status == "running") {
        return "btn-secondary btn-default btn btn-secondary button-14-medium px-3 py-12px ml-4px ml-xl-1 order-3";
      }
      return "btn-primary btn-default button-14-medium px-3 py-12px ml-4px ml-xl-1 order-3";
    },
    noGAID() {
      if (!this.details) {
        return false;
      }
      if (this.shopInfo && !this.shopInfo.gaLoggedIn) {
        return true;
      }
      const gaSettings = this.shopInfo?.accountInfo?.webAnalyticsTools?.ga;
      if (!gaSettings) {
        return true;
      }
      return (!gaSettings.gaAccountId || !gaSettings.gaAccountId.length)
        || (!gaSettings.gaPropertyId || !gaSettings.gaPropertyId.length)
    },
    btnReportTooltip() {
      return this.noGAID ? this.$t('analytic.ab.tooltipNoTrack') : '';
    },
  },
  watch: {
    attach: {
      deep: true,
      handler() {
        this.$forceCompute("details");
      }
    }
  },
  created() {
    this.loading = true;
    this.fetchDetail({
      id: (this.attach && this.attach.id) || this.$route.params.id
    })
      .then(res => {
        this.fetched = res;
      })
      .catch(() => {
        this.gSnackbarCommit({
          message: this.$t("status.error"),
          type: "error"
        });
        // this.$router.push({ name: "ABTesting"});
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    ...mapActions("analytic", {
      fetchDetail: actions.FETCH_DETAIL_ANALYTIC,
      startCampaign: actions.START_CAMPAIGN_ANALYTIC,
      stopCampaign: actions.STOP_CAMPAIGN_ANALYTIC,
      removeCampaign: actions.DELETE_CAMPAIGN_ANALYTIC,
      updateCampaign: actions.UPDATE_CAMPAIGN_ANALYTIC,
      addVariants: actions.ADD_VARIANTS_ANALYTIC,
      updatePagesPercent: actions.UPDATE_PERCENTS_ANALYTIC,
    }),
    ...mapActions("page", {
      updateRunningCampaignId: "updateRunningCampaignId"
    }),
    getPrimaryText(defaultText = "analytic.ab.addVariant") {
      return {
        default: defaultText,
        error: "generals.error",
        loading: "generals.loading",
        success: "generals.success"
      };
    },
    closeModal(type) {
      this.alertText = "";
      this.modals[type].active = false;
      // this.resetStatus();
    },
    isModalActive(type) {
      return this.modals[type].active;
    },
    openModal(type, field, value) {
      this.modals[type].active = true;
      this.modals[type][field] = value;
    },
    onStatusIndicate(value) {
      if (value == true) {
        if (this.fetched) this.fetched.indicating = true;
      } else {
        if (this.fetched) {
          this.fetched.indicating = false;
        }
      }
      this.$forceCompute("details");
    },
    onStatusUpdate(value) {
      if (this.fetched) {
        this.fetched.indicating = false;
        this.fetched.status = value;
        this.$forceCompute("details");
      }
    },
    copyURL() {
      var copyText = this.testURL;
      copyToClipboard(copyText);
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 1000);
    },
    statusFormat(value) {
      return statusFormat(value);
    },
    start() {
      let textSuccess = this.$t("status.success");
      this.gSnackbarCommit({
        message: this.$t("status.processing"),
        type: "loading"
      });
      this.onStatusIndicate(true);
      this.startCampaign({ id: this.details.id })
        .then(() => {
          this.updateRunningCampaignId({id: this.details.id});
          this.gSnackbarCommit({
            message: textSuccess,
            type: "success"
          });
          this.onStatusUpdate("running");
        })
        .catch(err => {
          this.gSnackbarCommit({
            message: this.getErrorMessage(err),
            type: "error"
          });
        })
        .finally(() => {
          this.onStatusIndicate(false);
        });
    },
    stop() {
      let textSuccess = this.$t("status.success");
      this.gSnackbarCommit({
        message: this.$t("status.processing"),
        type: "loading"
      });
      this.onStatusIndicate(true);
      this.stopCampaign({ id: this.details.id })
        .then(() => {
          this.updateRunningCampaignId({id: 0});
          this.gSnackbarCommit({
            message: textSuccess,
            type: "success"
          });
          this.onStatusUpdate("on_hold");
        })
        .catch(err => {
          this.gSnackbarCommit({
            message: this.getErrorMessage(err),
            type: "error"
          });
        })
        .finally(() => {
          this.onStatusIndicate(false);
        });
    },
    addVariant(pageIDs) {
      const id = this.details && this.details.id;
      let textSuccess = this.$t("status.success");
      this.gSnackbarCommit({
        message: this.$t("status.processing"),
        type: "loading"
      });
      this.activeLoading();
      this.addVariants({ id, variantIDs: pageIDs, pageType: this.mainPage && this.mainPage.g_type })
        .then(() => {
          this.gSnackbarCommit({
            message: textSuccess,
            type: "success"
          });
          this.activeSuccess();
          this.closeModal("addVariant");
        })
        .catch(err => {
          this.gSnackbarCommit({
            message: this.getErrorMessage(err),
            type: "error"
          });
          this.activeError();
        })
        .finally(() => {
          setTimeout(() => {
            this.resetStatus();
          }, 2000);
        });
    },
    onUpdatePercent({ main, variants }) {
      const avg = variants / (this.details.pages.length - 1);
      this.fetched.pages.forEach(item => {
        if (item.is_main_page) {
          item.percent = main;
        } else {
          item.percent = avg;
        }
      });
      this.closeModal("percent");
    },
    onRename(val) {
      this.fetched.name = val;
    },
    onDelete() {
      this.$router.push({ name: "ABTesting" });
    },
    onSetting(data) {
      for (const key in data) {
        const altKey = camelToSnake(key);
        this.fetched[altKey] = data[key];
      }
      this.$forceCompute("details");
      this.$forceCompute("noGAID");
    },
    appendPage(page) {
      this.fetched?.pages?.push(page);
    },
    openChangeVariant(item) {
      this.modals.changeVariant.oldID = item.g_id;
      this.openModal("changeVariant");
    },
    closeChangeVariant() {
      this.modals.changeVariant.oldID = null;
      this.closeModal("changeVariant");
    },
    changeVariant(newV) {
      let textSuccess = this.$t("status.success");
      const pages = this?.details?.pages?.map(x => {
        const item = {
          id: x.g_id,
          percent: x.percent,
          isMainPage: !!x.is_main_page
        };
        if (item.id == this.modals.changeVariant.oldID) {
          item.id = newV[0];
        }
        return item;
      }) || [];
      this.gSnackbarCommit({
        message: this.$t("status.processing"),
        type: "loading"
      });
      this.activeLoading();
      this.updatePagesPercent({ id: this.details.id, pages })
        .then((data) => {
          this.gSnackbarCommit({
            message: textSuccess,
            type: "success"
          });
          this.fetched.pages = data.pages;
          this.activeSuccess();
        })
        .catch(err => {
          this.gSnackbarCommit({
            message: this.getErrorMessage(err),
            type: "error"
          });
          this.activeError();
        })
        .finally(() => {
          this.closeChangeVariant();
          setTimeout(() => {
            this.resetStatus();
          }, 1000);
        });
    },
    previewClassByItem(item) {
      const noPreviewLink = !item.preview_url;
      return {
        "action-btn clickable": !noPreviewLink,
        "disabled": noPreviewLink,
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pe-none {
  pointer-events: none;
}
.text-accent-green {
  color: $accent-green;
}
.btn-copy {
  color: $mono3;
  padding: 0px;
  &:hover {
    color: $mono2;
  }
}
.btn-square {
  width: 40px;
  height: 40px;
  padding: 8px;
  @include trans-all;
}
.btn.btn-setting {
  &:not(:disabled):not(.disabled) {
    border-radius: $radius;
    background: $light1;
    color: $dark6;
    &:hover {
      background: $textDarkModeHigh;
    }

    path {
      fill: $dark6;
    }
  }
  &:disabled,
  &.disabled {
    path {
      fill: $textLightModeDisabled;
    }

    background: $textDarkModeHigh;
    color: $textLightModeDisabled;
  }
}
.action-btn {
  background: $light2;
  color: $textLightModeLow;
  &:hover {
    background: $textDarkModeHigh;
    color: $textLightModeHigh;
  }
}
.breadcrumb {
  .rl {
    color: $textLightModeLow;
    &:hover {
      color: $cSecondary2;
    }
    &.text-dark6 {
      color: $dark6;
    }
  }
}
.w {
  &200 {
    width: 200px;
  }
  &55 {
    width: 55px;
  }
  &38 {
    width: 38px;
  }
}
.h {
  &19 {
    height: 19px;
  }
  &15 {
    height: 15px;
  }
}
table.statistic {
  thead {
    th {
      border: 1px solid $light3;
      background: $light1;
      padding: 8px;
      border-collapse: collapse;

      &:not(.text-left) {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
.spinning {
  animation-name: spin;
  animation-duration: 500ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
.warning-no-tracking {
  padding: 18px 16px;
  border-radius: $radius;
  background: #fed571;
  position: relative;
}

.btn-preview {
  &.disabled {
    background: #f4f4f4;
    color: #a6a6a6;
  }
}

.btn {
  path {
    fill: $textDarkModeHigh;
  }

  &:disabled, &.disabled {
    color: $light1;
    background-color: #D6D6D6;

    path {
      fill: $light1;
    }
  }
}

</style>
